import cx from 'clsx';
import * as React from 'react';

import * as styles from './RosreestrSection.css';
import { CollapseButton } from '../../CollapseButton';

interface IRosreestrSectionProps {
  hasShowMoreButton: boolean;
  onShowMoreClick(): void;
  isRedesign?: boolean;
}

export const RosreestrSection: React.FC<React.PropsWithChildren<IRosreestrSectionProps>> = ({
  children,
  hasShowMoreButton,
  isRedesign,
  onShowMoreClick,
}) => {
  return (
    <div className={cx(styles['container'], isRedesign && styles['redesign'])}>
      <div className={styles['title']}>Информация из Росреестра</div>
      {children}
      {hasShowMoreButton && (
        <div className={styles['button']}>
          <CollapseButton isCollapsed={hasShowMoreButton} collapsedText="Посмотреть всё" onClick={onShowMoreClick} />
        </div>
      )}
    </div>
  );
};
